import React, { useState } from "react";
import Cookies from "js-cookie";
import trData from "../Assets/tr.json";

export default function AfisEkleModal({ onClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [baslik, setBaslik] = useState("");
  const [tarih, setTarih] = useState("");
  const [saat, setSaat] = useState("");
  const [sehir, setSehir] = useState("");
  const [ilce, setIlce] = useState("");
  const [ulke, setUlke] = useState("Türkiye");
  const [topluluk, setTopluluk] = useState("1001");
  const [kategori, setKategori] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const categoriesList = [
    '#UT: KAFELER-OTELLER',
    '#ŞİRKET: WEBİNAR-OPP-DİĞER',
    '#UT: NDO-AKADEMİ',
    '#UT: AVRUPA',
    '#UT: WEBİNAR',
    '#UT: EĞİTİMLER-VİDEOLAR',
    '#UT: GÜNLÜK BÜLTEN'
  ];

  const communities = [
    { label: 'Şirket', value: '1000' },
    { label: 'Universal team', value: '1001' },
    { label: 'Ekibim', value: '1002' },
    { label: 'Referanslarım', value: '1003' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !baslik || !tarih || !topluluk || !kategori) {
      setMessage("Lütfen zorunlu alanları doldurun.");
      return;
    }

    const token = Cookies.get("token");
    const bitisTarihi = saat ? `${tarih} ${saat}` : `${tarih} 00:00`;

    const datas = {
      token,
      afisBaslik: baslik,
      bitisTarihi: bitisTarihi,
      topluluk: topluluk,
      kategoriler: [kategori.replace("#", "")],
      ulke: ulke,
      sehir: sehir,
      ilce: ilce
    };

    const formData = new FormData();
    formData.append("afis", file);
    formData.append("datas", JSON.stringify(datas));

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/afis/ekle`, {
        method: "POST",
        body: formData
      });
      const data = await res.json();
      
      if (data.m === "basarili") {
        setMessage("Afiş başarıyla eklendi.");
        setTimeout(() => {
          onSuccess();
          onClose();
        }, 1500);
      } else {
        setMessage(data.m === "yetkinyok" ? "Afiş ekleme yetkiniz yok." : "Afiş eklenirken hata oluştu.");
      }
    } catch (err) {
      setMessage("Sunucu hatası.");
    } finally {
      setLoading(false);
    }
  };

  const selectedCityData = trData.find(c => c.text === sehir);
  const districts = selectedCityData ? selectedCityData.districts : [];

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", zIndex: 10500, display: "flex",
      justifyContent: "center", alignItems: "center", overflowY: "auto", padding: "20px"
    }}>
      <div className="bg-white rounded-4 shadow-lg border-0" style={{ width: "100%", maxWidth: "600px", position: "relative", overflow: "hidden" }}>
        <div className="p-4 border-bottom d-flex justify-content-between align-items-center bg-light">
          <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
            <i className="fa-solid fa-images me-2" style={{ color: "#0071f8" }}></i> Yeni Afiş Paylaş
          </h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>
        <div className="p-4" style={{ maxHeight: "75vh", overflowY: "auto" }}>
          <form onSubmit={handleSubmit}>
            {message && <div className="alert alert-info py-2">{message}</div>}
            
            <div className="mb-4 text-center">
              <div 
                className="border rounded-3 p-3 position-relative" 
                style={{ 
                  borderStyle: "dashed",
                  borderWidth: "2px",
                  borderColor: "#0071f8", 
                  backgroundColor: "#f9fbfd", 
                  cursor: "pointer",
                  minHeight: "150px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden"
                }}
                onClick={() => document.getElementById('afisUploadInput').click()}
              >
                {file ? (
                  <img 
                    src={URL.createObjectURL(file)} 
                    alt="Afiş Önizleme" 
                    style={{ maxHeight: "250px", maxWidth: "100%", objectFit: "contain", borderRadius: "8px" }} 
                  />
                ) : (
                  <>
                    <i className="fa-solid fa-cloud-arrow-up mb-2" style={{ fontSize: "2rem", color: "#0071f8" }}></i>
                    <span className="fw-bold" style={{ color: "#0071f8" }}>Afiş Görseli Yükle</span>
                    <span className="small text-muted mt-1">Sürükle bırak veya seçmek için tıkla</span>
                  </>
                )}
              </div>
              <input 
                id="afisUploadInput"
                type="file" 
                className="d-none" 
                accept="image/*" 
                onChange={(e) => setFile(e.target.files[0])} 
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold small text-muted">Afiş Başlığı *</label>
              <input type="text" className="form-control shadow-sm" style={{ border: "1px solid #e2e8f0" }} placeholder="Örn: İş Fırsat Sunumu" value={baslik} onChange={e => setBaslik(e.target.value)} required />
            </div>

            <div className="row mb-3">
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">Tarih *</label>
                <input type="date" className="form-control shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={tarih} onChange={e => setTarih(e.target.value)} required />
              </div>
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">Saat</label>
                <input type="time" className="form-control shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={saat} onChange={e => setSaat(e.target.value)} />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">Topluluk *</label>
                <select className="form-select shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={topluluk} onChange={e => setTopluluk(e.target.value)} required>
                  {communities.map((c, i) => <option key={i} value={c.value}>{c.label}</option>)}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">Kategori *</label>
                <select className="form-select shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={kategori} onChange={e => setKategori(e.target.value)} required>
                  <option value="">Seçiniz...</option>
                  {categoriesList.map((c, i) => <option key={i} value={c}>{c}</option>)}
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">Şehir</label>
                <select className="form-select shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={sehir} onChange={e => { setSehir(e.target.value); setIlce(""); }}>
                  <option value="">Seçiniz...</option>
                  {trData.map(c => <option key={c.value} value={c.text}>{c.text}</option>)}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label fw-bold small text-muted">İlçe</label>
                <select className="form-select shadow-sm" style={{ border: "1px solid #e2e8f0" }} value={ilce} onChange={e => setIlce(e.target.value)} disabled={!sehir}>
                  <option value="">Seçiniz...</option>
                  {districts.map(d => <option key={d.value} value={d.text}>{d.text}</option>)}
                </select>
              </div>
            </div>

            <div className="text-end mt-4 pt-3 border-top">
              <button type="button" className="btn btn-light me-3 px-4 rounded-pill fw-bold" onClick={onClose}>İptal</button>
              <button type="submit" className="btn btn-primary px-4 rounded-pill fw-bold" disabled={loading} style={{ backgroundColor: "#0071f8", border: "none", boxShadow: "0 4px 10px rgba(0,113,248,0.2)" }}>
                {loading ? (
                  <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Paylaşılıyor...</>
                ) : (
                  <>Afişi Paylaş <i className="fa-solid fa-paper-plane ms-2"></i></>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
